import { render, staticRenderFns } from "./EventInfoCore.vue?vue&type=template&id=5970c156&scoped=true&"
import script from "./EventInfoCore.vue?vue&type=script&lang=ts&"
export * from "./EventInfoCore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5970c156",
  null
  
)

export default component.exports